(() => {
  const root = document.documentElement;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const itemSelector = [
    '.ck-product-card',
    '.cs-product-card',
    '.ck-cat-card',
    '.cs-category',
    '.ck-use-case',
    '.cs-promo',
    '.cs-build-tile',
    '.cs-benefit-grid article',
    '.cs-service-strip article',
    '.ck-trust-strip > *',
    '.ck-proof > *',
    '.ck-process > *',
    '.ck-product-specs-band > *'
  ].join(',');

  if (!('IntersectionObserver' in window)) return;

  let observer;

  const uniqueElements = (elements) => [...new Set(elements)];

  const getSectionTargets = () => {
    const targets = [];
    document.querySelectorAll('main#MainContent > .shopify-section').forEach((section) => {
      const home = section.querySelector('.cs-home');
      if (home) {
        targets.push(...home.querySelectorAll(':scope > section'));
      } else {
        targets.push(section);
      }
    });

    targets.push(...document.querySelectorAll('.ck-footer'));
    return uniqueElements(targets);
  };

  const setMotionTarget = (element, index, item = false) => {
    if (element.dataset.ckMotionReady === 'true') return;

    element.dataset.ckMotionReady = 'true';
    element.classList.add(item ? 'ck-motion-item' : 'ck-motion-target');

    const siblings = element.parentElement
      ? [...element.parentElement.children].filter((sibling) => sibling.matches(item ? itemSelector : 'section, .shopify-section, .ck-footer'))
      : [];
    const siblingIndex = siblings.indexOf(element);
    const delay = Math.min(Math.max(siblingIndex >= 0 ? siblingIndex : index, 0) * (item ? 65 : 90), item ? 360 : 420);
    element.style.setProperty('--ck-motion-delay', `${delay}ms`);
  };

  const setupMotion = () => {
    if (reduceMotion.matches) return;

    root.classList.add('ck-motion-ready');
    const sections = getSectionTargets();
    sections.forEach((section, index) => setMotionTarget(section, index));

    const items = uniqueElements([
      ...document.querySelectorAll(itemSelector),
      ...sections.flatMap((section) => [...section.querySelectorAll(itemSelector)])
    ]);
    items.forEach((item, index) => setMotionTarget(item, index, true));

    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('ck-motion-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -7% 0px', threshold: 0.08 });
    }

    [...sections, ...items].forEach((element) => {
      if (!element.classList.contains('ck-motion-visible')) observer.observe(element);
    });
  };

  const disableMotion = () => {
    root.classList.remove('ck-motion-ready');
    document.querySelectorAll('.ck-motion-target, .ck-motion-item').forEach((element) => {
      element.classList.add('ck-motion-visible');
      element.dataset.ckMotionReady = 'false';
      element.style.removeProperty('--ck-motion-delay');
    });
  };

  setupMotion();
  document.addEventListener('shopify:section:load', () => window.setTimeout(setupMotion, 0));

  const handleMotionPreference = () => {
    if (reduceMotion.matches) disableMotion();
    else setupMotion();
  };

  if (typeof reduceMotion.addEventListener === 'function') {
    reduceMotion.addEventListener('change', handleMotionPreference);
  } else {
    reduceMotion.addListener(handleMotionPreference);
  }

  document.querySelectorAll('[data-story-switcher]').forEach((switcher) => {
    const tabs = [...switcher.querySelectorAll('[data-story-tab]')];
    const index = switcher.querySelector('.ck-story-switcher__index');
    const copy = switcher.querySelector('[data-story-copy]');
    const content = [
      { label: 'TUNE', text: 'A considered parts list tuned around your real workflow, not a generic spec sheet.' },
      { label: 'TEST', text: 'Every build is stress-tested, cable-managed, and checked before it leaves our bench.' },
      { label: 'SUPPORT', text: 'Clear guidance after delivery, backed by a team that understands the machine you chose.' }
    ];

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const selected = Number(tab.dataset.storyTab);
        tabs.forEach((item) => {
          const active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
        });
        if (index && copy && content[selected]) {
          index.textContent = `0${selected + 1} / ${content[selected].label}`;
          copy.textContent = content[selected].text;
        }
      });
    });
  });
})();
